import { useEffect } from 'react';
import { getSiteTitle } from '../config/siteConfig';

/**
 * Custom hook to set page title dynamically
 * @param {string} pageTitle - The title for the current page
 */
export const usePageTitle = (pageTitle = '') => {
  useEffect(() => {
    const title = getSiteTitle(pageTitle);
    document.title = title;
  }, [pageTitle]);
};

export default usePageTitle;

